import React, { useEffect, useState, useRef } from 'react';
import { compose } from 'ramda';
import styleFile from './header.js';

import { RichText, Button, Image } from '@synergycms_core/components/generic';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';

const PHONE_CONFIG = [
  { titleKey: '_%primary_phone_title%_', phoneKey: '_%primary_phone%_' },
  { titleKey: '_%secondary_phone_title%_', phoneKey: '_%secondary_phone%_' }
];

const sanitizePhoneForHref = (phone) => {
  if (!phone) return '';
  const cleaned = phone.replace(/[^\d+-]/g, '').replace(/[\s()]/g, '');
  return `tel:${cleaned}`;
};

const PhoneItem = ({ titleKey, phoneKey, phoneNumber, classes }) => (
  <>
    <a 
      rel="noopener" 
      href={sanitizePhoneForHref(phoneNumber)} 
      className={classes.phoneLink}
    >
      <RichText
        innerStyle={classes.phoneCtn}
        text={titleKey}
        translate={true}
      />
      <RichText
        innerStyle={classes.phoneNumber}
        text={phoneKey}
        translate={true}
      />
    </a>
  </>
);

const useClickOutside = (ref, callback) => {
  useEffect(() => {
    const handleEventsOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener('pointerdown', handleEventsOutside);
    document.addEventListener('scroll', handleEventsOutside, true);
    
    return () => {
      document.removeEventListener('pointerdown', handleEventsOutside);
      document.removeEventListener('scroll', handleEventsOutside, true);
    };
  }, [ref, callback]);
};

const PhoneSelector = ({ theme, content }) => {
  const { classes } = theme.styles;
  const [isOpen, setIsOpen] = useState(false);
  const selectorRef = useRef(null);
  
  const validPhones = PHONE_CONFIG.filter(
    ({ titleKey, phoneKey }) => 
      content.getHasKeyAndContent(titleKey) && content.getHasKeyAndContent(phoneKey)
  ).map(phone => ({
    ...phone,
    phoneNumber: content.t(phone.phoneKey)
  }));

  useClickOutside(selectorRef, () => setIsOpen(false));

  if (validPhones.length === 0) return null;

  return (
    <div className={classes.phoneContainer} ref={selectorRef}>
      <Button
        onClick={() => setIsOpen(prev => !prev)}
        innerStyle={classes.phoneBox}
        ariaLabel="_%mostrar números de teléfono%_"
        translate={true}
      >
        <Image svg="phone" innerStyle={[classes.phoneDispoEngine]} />
      </Button>

      {isOpen && (
        <div className={classes.phoneWrapper}>
          {validPhones.map(({ titleKey, phoneKey, phoneNumber }) => (
            <PhoneItem
              key={phoneKey}
              titleKey={titleKey}
              phoneKey={phoneKey}
              phoneNumber={phoneNumber}
              classes={classes}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default compose(
  withContent('i18n'),
  withThemeJSS({ styleFile, displayName: 'Header' })
)(PhoneSelector);